'use strict';
module.exports = require('./Dropdown.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/dropdown/index.js
// module id = 9
// module chunks = 1